module.exports = __webpack_public_path__ + "img/PubMed.8bc690c5.png";